import { Checkbox, FormControlLabel, Stack } from "@mui/material";
import { useState } from "react";

import Modal from "@components/Modal";

import TermsConsent from "@containers/RegistrationFlow/TermsConsent";

import service from "../../../services/userService";

interface PolicyModalProps {
  userId: string;
  updateAuthUser: (data: {
    noShowConsent: boolean;
    termsConsent: boolean;
  }) => void;
}

const PolicyModal = (props: PolicyModalProps) => {
  const [termsChecked, setTermsChecked] = useState(false);

  const onSubmit = async () => {
    const data = {
      noShowConsent: true,
      termsConsent: true,
    };
    try {
      await service.signConsentDocuments(props.userId);
      await service.updateProfile(data, props.userId);
    } catch (error) {
      console.log(error);
    }
    props.updateAuthUser(data);
  };

  return (
    <Modal
      open={true}
      title="Updated Terms"
      bodyParagraphs={[
        "We have recently updated our terms and conditions, including a new no-show policy. Please read and agree to the following:",
      ]}
      buttons={[
        {
          label: "Continue",
          onClick: onSubmit,
          variant: "contained",
          disabled: !termsChecked,
        },
      ]}
    >
      <Stack direction="column" alignItems="center" spacing={0}>
        <FormControlLabel
          control={
            <Checkbox
              checked={termsChecked}
              onChange={(e) => setTermsChecked(e.target.checked)}
            />
          }
          label="I've read and agreed to the following:"
        />
        <TermsConsent />
      </Stack>
    </Modal>
  );
};

export default PolicyModal;
